<template>
  <div class="leveled">     
      
    <div id="componentBox2" ref="componentBox">
      <div class="mark">Theoretisch.vue</div>

      <div id="mat" class="container relative">
        <div class="row relative">
          <div class="col col-1 no-pad relative">            
           
            <div class="nav-side material"  v-bind:style="getHeightOfApp">
              
            </div>

              
          </div>
        
        <div class="col col-11 no-pad">

          <h1>Lesmateriaal theoretisch</h1>

          <!-- les 1 -->
          <div id="les1" class="card-deck" 
           @mouseover="hoverLesOne = true"
            @mouseleave="hoverLesOne = false">
            <div :class="{ active: hoverLesOne }" id="knob-les-1" class="knob-les">
                <h4 class="les-num-knob">Les 1</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('theoretisch') && materiaal.acf.mat_les==1" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">                  
                  

                  <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>

                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>


          
          <!-- les 2 -->
          <div id="les2" class="card-deck"
          @mouseover="hoverLesTwo = true"
            @mouseleave="hoverLesTwo = false">
            <div class="knob-les" :class="{ active: hoverLesTwo }">
                <h4 id="knob-les-2" class="les-num-knob">Les 2</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('theoretisch') && materiaal.acf.mat_les==2" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">
                  <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>



          <!-- les 3 -->
          <div id="les3" class="card-deck"
          @mouseover="hoverLesThree = true"
            @mouseleave="hoverLesThree = false">
            <div class="knob-les" :class="{ active: hoverLesThree }">
                <h4 id="knob-les-3" class="les-num-knob">Les 3</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('theoretisch') && materiaal.acf.mat_les==3" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">
                  <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>




          <!-- les 4 -->
          <div id="les4" class="card-deck"
          @mouseover="hoverLesFour = true"
            @mouseleave="hoverLesFour = false">
            <div class="knob-les" :class="{ active: hoverLesFour }">
                <h4 id="knob-les-4" class="les-num-knob">Les 4</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('theoretisch') && materiaal.acf.mat_les==4" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">
                  <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf"  v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>

            


          <div class="card" v-for="(item, index) of kahoot" v-bind:key="item.id">
            <div class="card-top-img" style="background-image: url(&quot;https://samenfris.nl/wp/wp-content/uploads/2019/09/quiz.png&quot;);"></div>

             <div class="card-body">
              <div>
                <h5 class="card-title">Eindquiz {{ item.title.rendered }}</h5>
                <p class="card-text">Waar of niet waar? Vragen over roken, alcohol drinken en blowen.</p></div>
              </div>
              <div class="card-footer">
                <p @click="show(item.les2_questions)" class="round-btn-yel"></p>
              </div>
            </div>









          <modals-container/>


        </div>
      </div>
      </div>
    </div>

    </div>        
  </div>
</template>


<script>
  import Vue from 'vue'
  import Vue2Filters from 'vue2-filters'
  Vue.use(Vue2Filters)
  import vueVimeoPlayer from 'vue-vimeo-player'
  Vue.use(vueVimeoPlayer)

   export default {
       mixins: [Vue2Filters.mixin],
        name: 'praktisch',
        props:['id'],    

        data: function () {
            return {
              getHeightOfApp: { },
              materiaal:'',
              materiaals:[],
              options: {responsive: true},
              playerReady: false,
              hoverLesOne: true,
              hoverLesTwo: false,
              hoverLesThree: false,
              hoverLesFour: false,
              modaltext:'dfsdsfsfsf',
              authorIdVue: localStorage.getItem("userID"),
              kahoot:[]
              



            }
        },

        components: { vueVimeoPlayer },

        created() {
            this.fetchMat(); 
            this.fetchData();       
        },

        mounted () {
          this.$nextTick(() => {
            //  ¯\_(ツ)_/¯
            this.matchHeight();
            
            
          });
         
        },

        ////////////////
    
        methods: { 

          fetchData(id){
            const params = {
              author: this.authorIdVue
            };
            var self = this;
            
            self.axios.get(Vue.prototype.$hostname+"/wp/wp-json/wp/v2/classes/?filter[meta_key]=onderwijstype&filter[meta_value]=theoretisch",{ params }).then(response => {
              self.kahoot = response.data;
              console.log(self.kahoot);
            });
          },



          show (questions) {
            this.$modal.show({
              template: `
                <div>
                  <div class="mod-header">
                    <h2>Quizvragen les 4 <span>Endquiz Samen Fris</span></h2>
                  </div>
                  <h3>Eindquiz</h3>                  
                  <div class="modal-text" v-html="modaltext"></div>
                  <div class="end-modal"></div>
                </div>
              `,
              props: ['modaltext']
            }, {
              modaltext: questions
            }, {
              height: 'auto'
            }, {
              'before-close': (event) => { console.log('this will be called before the modal closes'); }
            })

          },
          hide () {
            this.$modal.hide('hello-world');
          },    
      
          matchHeight () {          
            var heightString = $('#componentBox2').height();
            $('.nav-side').height(heightString-500);  
          },

          fetchMat(){
            var self = this;
            this.axios.get(Vue.prototype.$hostname+"/wp/wp-json/wp/v2/materiaals/?per_page=100",).then(response => {
              this.materiaals = response.data;
              //console.log('data loaded');
                  setTimeout(() => { 
                          this.matchHeight();

                          console.log(self.$route.query.goto);
                          if (self.$route.query.goto) {
                            let elToScr = document.getElementById(self.$route.query.goto); 
                            self.$scrollTo(elToScr, 1000,{easing: 'ease-out',offset: -20});
                          }

                        },1000);

              

            });
          },


          onReady() {
            this.playerReady = true
          },
          play () {
            this.$refs.player.play()
          },
          pause () {
            this.$refs.player.pause()
          },

          







        }
      }
</script>

<style lang="scss">
.vimeo {
  left: 0;
  top: 0;
  height: 198px;
  width: 299px;
  position: relative;
}
.v--modal {
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.2);
    padding: 0 0 20px 0;

    left: 10% !important;
    width: 80% !important;

}
#modals-container{
  .modal-text{
    white-space: pre;
    font-size: 16px;
    padding: 20px;
    font-family: 'Bree Serif', serif;
    font-weight: 400;
  }
  .end-modal{
    background-position: 94% 0px;
    background-repeat: no-repeat;
    background-image: url(../img/question.png);
    background-size: contain;
    height: 140px;
  }

  .mod-header{
  background-color: #d6793f;
  padding: 20px 20px 50px 20px;
  h2{
    font-size: 20px;
    span{
      font-size: 16px;
      float: right;
    }
  }
  
}
h3{
    margin-top: 15px;
    text-align: center;
    font-size: 18px;
    background-color: #f6daa1;
    padding: 15px 20px 35px 15px;
  }
}
  .v--modal-overlay {
    background: rgba(250, 250, 250, 0.6) !important;
  }
</style> 